module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('workspace', [_c('div', {
    attrs: {
      "slot": "form"
    },
    slot: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "imageUrl"
    }
  }, [_vm._v("Image URL")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageUrl),
      expression: "imageUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "imageUrl"
    },
    domProps: {
      "value": (_vm.imageUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageUrl = $event.target.value
      }
    }
  }), _c('p', {
    staticClass: "help-block"
  }, [_vm._v("Image size: 600px x 300px")])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "alt"
    }
  }, [_vm._v("Alt Text")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alt),
      expression: "alt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "alt"
    },
    domProps: {
      "value": (_vm.alt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alt = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group clearfix",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "refresh"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  }), _vm._v(" Reset")]), _c('div', {
    staticClass: "btn pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "copyHtml",
      "aria-label": "Copied HTML!"
    },
    on: {
      "click": _vm.copy
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" Copy HTML")])])])]), _c('tr', {
    attrs: {
      "slot": "render"
    },
    slot: "render"
  }, [_c('td', [_c('table', {
    staticStyle: {
      "table-layout": "fixed"
    },
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "600"
    }
  }, [_c('tr', [_c('td', [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('img', {
    staticClass: "fluid-image",
    staticStyle: {
      "display": "block",
      "padding": "0",
      "color": "#ffffff",
      "font-family": "Helvetica, arial, sans-serif",
      "font-size": "22px",
      "line-height": "28px"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "600",
      "height": "300",
      "border": "0",
      "alt": _vm.alt
    }
  })])])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2445d068"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jaoa/banner.vue
// module id = 215
// module chunks = 0